export default __webpack_public_path__ + "static/media/G-3.5e018f19.svg";